var map = {
	"./cs.json": 82173,
	"./da.json": 90466,
	"./de.json": 20015,
	"./en-GB.json": 5616,
	"./en.json": 37115,
	"./es.json": 31661,
	"./fr-CA.json": 69062,
	"./fr.json": 22606,
	"./it.json": 98010,
	"./ja.json": 73841,
	"./ko.json": 95233,
	"./nl.json": 40097,
	"./no.json": 1668,
	"./pl.json": 87726,
	"./pt-BR.json": 15788,
	"./ru.json": 17700,
	"./sv.json": 82043,
	"./zh-Hans.json": 5421,
	"./zh-Hant.json": 43293
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9463;